(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-blog-section"] && !Shopify.designMode) return;
  try {
    
  /* Supply6 perf: slick is no longer a globally loaded library - custom.js fetches it on
     demand via s6LoadLib(name, globalName, cb). Ask the loader for slick once if it
     is missing, then run the same init. */
  (function () {
    var slickRequested = false;
    function initLatestBlogsSlider() {
      if (!window.jQuery || !jQuery.fn) return;
      if (!jQuery.fn.slick) {
        if (!slickRequested && typeof window.s6LoadLib === 'function') {
          slickRequested = true;
          window.s6LoadLib('slick', 'slick', initLatestBlogsSlider);
        }
        return;
      }
    $('.latest-blogs__slider').not('.slick-initialized').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 741,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLatestBlogsSlider);
    else initLatestBlogsSlider();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-get-duo-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof window.jQuery === 'undefined') return;

    var $ = window.jQuery;
    var BUTTONS = '.listicle-duo-bundle_cta--button, .sticky_listicle-duo-bundle_cta--button';

    function formatMoney(cents, format) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      function group(decimals, thousands, decimal) {
        var parts = (cents / 100.0).toFixed(decimals).split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts[1] ? whole + decimal + parts[1] : whole;
      }

      var placeholder = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
      var name = placeholder ? placeholder[1] : 'amount';
      var value;

      switch (name) {
        case 'amount_no_decimals':
          value = group(0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = group(2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = group(0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = group(2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = group(0, ' ', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = group(2, "'", '.');
          break;
        default:
          value = group(2, ',', '.');
      }

      return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    // Live bundle total = every active line item's variant price x its quantity.
    // Writes to the in-card price and the sticky bar from the same calculation.
    function updateTotals($scope) {
      var $price = $scope.find('.listicle-duo-bundle__price');
      var $sticky = $scope.find('.listicle-duo-bundle__sticky');
      var format = $price.attr('data-money-format') || $sticky.attr('data-money-format');
      if (!format) return;

      var total = 0;
      var compareTotal = 0;

      $scope.find('.listicle-packs-product.active').each(function () {
        var price = parseInt($(this).attr('data-price'), 10);
        if (isNaN(price)) return;

        var compare = parseInt($(this).attr('data-compare-price'), 10);
        if (isNaN(compare)) compare = price;

        var quantity = parseInt($(this).attr('data-quantity'), 10) || 1;

        total += price * quantity;
        compareTotal += compare * quantity;
      });

      var hasSaving = compareTotal > total;
      var prefix = $price.attr('data-compare-prefix') || '';

      $price.find('.listicle-duo-bundle__price--current').text(formatMoney(total, format));
      $price
        .find('.listicle-duo-bundle__price--compare')
        .text((prefix + ' ' + formatMoney(compareTotal, format)).trim())
        .prop('hidden', !hasSaving);

      if ($sticky.length === 0) return;

      $sticky.find('.listicle-duo-bundle__sticky-pay_value').text(formatMoney(total, format));
      $sticky.find('.listicle-duo-bundle__sticky-mrp_value').text(formatMoney(compareTotal, format));
      $sticky.find('.listicle-duo-bundle__sticky-save_value').text(formatMoney(compareTotal - total, format));
      $sticky
        .find('.listicle-duo-bundle__sticky-mrp, .listicle-duo-bundle__sticky-save')
        .prop('hidden', !hasSaving);
    }

    function showError($error, message) {
      $error.text(message).show();
      setTimeout(function () {
        $error.fadeOut();
      }, 3000);
    }

    // One active variant per multi-product group.
    $(document).on('click', '.listicle-packs-product_variant--list_item--wrapper', function () {
      var $option = $(this);

      $option
        .closest('.listicle-packs-product_variant--list')
        .find('.listicle-packs-product_variant--list_item--wrapper')
        .removeClass('active')
        .attr('aria-checked', 'false');

      $option.addClass('active').attr('aria-checked', 'true');

      var $section = $option.closest('.listicle-duo-bundle');
      $section.find('.listicle-duo-bundle_qty-cta_error').hide();
      updateTotals($section);
    });

    $(document).on('keydown', '.listicle-packs-product_variant--list_item--wrapper', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(this).trigger('click');
      }
    });

    $(document).on('click', BUTTONS, function () {
      // Scoped to the section, not the card, so the sticky button resolves too.
      var $section = $(this).closest('.listicle-duo-bundle');
      var $scope = $section.length ? $section : $('.listicle-duo-bundle').first();
      var $buttons = $(BUTTONS);
      var $error = $scope.find('.listicle-duo-bundle_qty-cta_error');
      var defaultQty = parseInt($scope.find('#listicle-duo-bundle--quantity_input').val(), 10) || 1;
      var missingSelection = false;

      // Every variant group needs a selection before the payload can be built.
      $scope.find('.listicle-packs-product_variant--list').each(function () {
        if ($(this).find('.listicle-packs-product_variant--list_item--wrapper.active').length === 0) {
          missingSelection = true;
        }
      });

      if (missingSelection) {
        showError($error, $error.data('message') || 'Choose Your Fibre+ Flavour');
        return;
      }

      var items = [];

      $scope.find('.listicle-packs-product.active').each(function () {
        var variantId = $(this).attr('variant_id');
        if (!variantId) return;

        items.push({
          id: variantId,
          quantity: parseInt($(this).data('quantity'), 10) || defaultQty
        });
      });

      if (items.length === 0) {
        showError($error, 'This bundle is not available right now.');
        return;
      }

      $buttons.prop('disabled', true).attr('aria-busy', true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items },
        dataType: 'json',

        error: function (jqXHR) {
          var response = {};

          try {
            response = JSON.parse(jqXHR.responseText);
          } catch (e) {}

          showError($error, response.description || 'Something went wrong. Please try again.');
          $buttons.prop('disabled', false).removeAttr('aria-busy');
        },

        success: function () {
          $buttons.prop('disabled', false).removeAttr('aria-busy');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
    });

    // Reveal the sticky bar only once the in-card button has scrolled out of view.
    function initSticky(root) {
      var mainButton = root.querySelector('.listicle-duo-bundle_cta--button');
      var sticky = root.querySelector('.listicle-duo-bundle__sticky');
      if (!mainButton || !sticky || typeof IntersectionObserver === 'undefined') return;

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', scrolledPast);
        });
      }).observe(mainButton);
    }

    function initStickyBars() {
      Array.prototype.forEach.call(document.querySelectorAll('.listicle-duo-bundle'), initSticky);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyBars);
    } else {
      initStickyBars();
    }

    document.addEventListener('shopify:section:load', initStickyBars);
  })();


  } catch(e) { console.error(e); }
})();
})();
